import { useEffect } from 'react'
import type { ReactNode } from 'react'
import ContentLayout from '@cloudscape-design/components/content-layout'
import type { BreadcrumbGroupProps } from '@cloudscape-design/components/breadcrumb-group'
import PageHeader from '@/components/common/PageHeader'
import { useHelpPanelStore } from '@/state/helpPanelStore'

interface PageProps {
  title: string
  description?: string
  actions?: ReactNode
  breadcrumbs?: BreadcrumbGroupProps['items']
  helpContent?: {
    header: string
    body: React.ReactNode
    footer?: React.ReactNode
  }
  children: ReactNode
}

export default function Page({ title, description, actions, breadcrumbs, helpContent, children }: PageProps) {
  const setContent = useHelpPanelStore((state) => state.setContent)

  useEffect(() => {
    if (helpContent) {
      console.log('[Page] Setting help content:', { header: helpContent.header, hasBody: !!helpContent.body })
      setContent(helpContent)
    } else {
      console.log('[Page] Clearing help content')
    }
    return () => {
      console.log('[Page] Cleanup: clearing help content')
      setContent(null)
    }
  }, [helpContent, setContent])

  return (
    <ContentLayout
      header={
        <PageHeader
          title={title}
          description={description}
          actions={actions}
          breadcrumbs={breadcrumbs}
          hasHelp={!!helpContent}
        />
      }
    >
      {children}
    </ContentLayout>
  )
}
